import api from "./api";
import auth from "./auth";

export default {
    getDetail() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/details", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    getUser() {
        return new Promise((resolve, reject) => {
            api.get(
                "merchant-auth-service/user/view/" + auth.getUser().uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    updateMerchantProfile(detail) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-service/cms/details/update",
                detail,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(status);
                    reject(status, error);
                });
        });
    },

    updateUserProfile(detail) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-auth-service/auth/update/profile",
                detail,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    updateDocument(documents) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-service/cms/documents/update",
                documents,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    getDocuments() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/documents", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    updateSecurityDetail(detail) {
        return new Promise((resolve, reject) => {
            api.post(
                "merchant-auth-service/auth/password/update",
                detail,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);

                    return reject(status);
                });
        });
    }
};
